import React from 'react';
import { Typography } from 'antd';
import { FiSearch } from 'react-icons/fi';

const { Title, Text } = Typography;

const VerificationLoadingCard = () => (
  <div
    style={{
      width: '100%',
      padding: '24px 16px',
    }}
  >

    <div
      style={{
        width: '100%',
        maxWidth: 860,
        margin: '0 auto',
        background: '#ffffff',
        border: '1px solid #bfdbfe',

        overflow: 'hidden',
        position: 'relative',
        zIndex: 1,
      }}
    >
      <div
        style={{
          height: 6,
          background:
            'linear-gradient(90deg, #2563eb 0%, #60a5fa 50%, #2563eb 100%)',
        }}
      />

      <div
        className="vlc-header"
        style={{
          background: '#f8fbff',
          borderBottom: '1px solid #dbeafe',
        }}
      >
        <div
          style={{
            textAlign: 'center',
            fontSize: 12,
            fontWeight: 700,
            color: '#1d4ed8',
            marginBottom: 18,
          }}
        >
          Official Documents Verification
        </div>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 24,
            flexWrap: 'wrap',
          }}
        >
          <div style={{ flex: 1, minWidth: 220 }}>
            <Title
              level={2}
              className="mb-2! text-[24px]! sm:text-[28px]!"
              style={{ color: '#0f172a' }}
            >
              Verifying Document
            </Title>
            <Text style={{ fontSize: 14, color: '#475569', lineHeight: 1.7 }}>
              Please wait while we retrieve the document record, validate its
              details, and prepare the verification result.
            </Text>
          </div>

          <div
            style={{
              width: 116,
              height: 116,
              borderRadius: '50%',
              border: '1px solid #bfdbfe',
              background: '#eff6ff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
              flexShrink: 0,
            }}
          >
            <div
              style={{
                position: 'absolute',
                inset: 10,
                borderRadius: '50%',
                border: '3px solid #93c5fd',
                borderTopColor: '#2563eb',
                animation: 'verifySpin 1.2s linear infinite',
              }}
            />
            <div
              style={{
                position: 'absolute',
                inset: 24,
                borderRadius: '50%',
                background: '#dbeafe',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#1d4ed8',
              }}
            >
              <FiSearch size={18} />
            </div>
          </div>
        </div>
      </div>

      <div className="vlc-body" style={{ background: '#ffffff' }}>

        <div
          style={{
            border: '1px solid #bfdbfe',
            background: '#f8fbff',
            padding: '16px 18px',
            marginBottom: 26,
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ flex: 1 }}>
              <div
                style={{
                  fontSize: 13,
                  fontWeight: 700,
                  color: '#1d4ed8',
                  marginBottom: 4,
                }}
              >
                Verification in progress
              </div>
              <div style={{ fontSize: 13, color: '#475569', lineHeight: 1.6 }}>
                Loading document information and checking authenticity records.
              </div>
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 0, marginBottom: 28 }}>

          <div className="vlc-row-3">
            {['Document Number', 'Document Type', 'Record Created At'].map((label, index) => (
              <div key={label} className="vlc-skel-block">
                <div className="vlc-skel-label">{label}</div>
                <div
                  className="vlc-shimmer"
                  style={{ width: index === 1 ? '62%' : '78%' }}
                />
              </div>
            ))}
          </div>

          <div className="vlc-row-1-2">
            {[
              { label: 'Application Type', width: '70%' },
              { label: 'Application Notes', width: '88%' },
            ].map(({ label, width }) => (
              <div key={label} className="vlc-skel-block">
                <div className="vlc-skel-label">{label}</div>
                <div className="vlc-shimmer" style={{ width }} />
              </div>
            ))}
          </div>

          <div className="vlc-row-3">
            {[
              { label: 'Application Items', lines: ['60%', '48%'] },
              { label: 'Issue Date', lines: ['66%'] },
              { label: 'Expiry Date', lines: ['72%'] },
            ].map(({ label, lines }) => (
              <div key={label} className="vlc-skel-block">
                <div className="vlc-skel-label">{label}</div>
                {lines.map((w, i) => (
                  <div
                    key={i}
                    className="vlc-shimmer"
                    style={{ width: w, marginTop: i > 0 ? 6 : 0 }}
                  />
                ))}
              </div>
            ))}
          </div>
        </div>

        <div style={{ marginBottom: 24 }}>
          <div
            style={{
              fontSize: 13,
              fontWeight: 700,
              color: '#1d4ed8',
              marginBottom: 14,
            }}
          >
            Security Code Validation
          </div>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
              gap: 16,
            }}
          >
            {[1, 2].map((n) => (
              <div
                key={n}
                style={{
                  border: '1px solid #bfdbfe',
                  background: '#f8fbff',
                  padding: '16px',
                }}
              >
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: '#64748b',
                    marginBottom: 12,
                  }}
                >
                  Security Code {n}
                </div>
                <div
                  style={{
                    height: 40,
                    display: 'flex',
                    alignItems: 'center',
                    padding: '0 12px',
                    background: '#dbeafe',
                    border: '1px solid #bfdbfe',
                  }}
                >
                  <div
                    style={{
                      height: 12,
                      width: '72%',
                      background:
                        'linear-gradient(90deg, #bfdbfe 25%, #dbeafe 50%, #bfdbfe 75%)',
                      backgroundSize: '200% 100%',
                      animation: 'verifyShimmer 1.6s infinite linear',
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        <div
          style={{
            borderTop: '1px solid #dbeafe',
            paddingTop: 16,
            textAlign: 'center',
            fontSize: 12,
            color: '#64748b',
            lineHeight: 1.7,
          }}
        >
          Please do not refresh the page while verification is in progress.
        </div>
      </div>
    </div>

    <style>{`
      @keyframes verifySpin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }

      @keyframes verifyShimmer {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
      }

      .vlc-header {
        padding: 32px 36px 22px;
      }

      .vlc-body {
        padding: 28px 36px 32px;
      }

      /* Skeleton grid rows — mirror the loaded card exactly */
      .vlc-row-3 {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        column-gap: 24px;
      }

      .vlc-row-1-2 {
        display: grid;
        grid-template-columns: 1fr 2fr;
        column-gap: 24px;
      }

      .vlc-skel-block {
        padding: 14px 0 12px;
        border-bottom: 1px solid #e2e8f0;
      }

      .vlc-skel-label {
        font-size: 11px;
        font-weight: 700;
        color: #64748b;
        margin-bottom: 10px;
      }

      .vlc-shimmer {
        height: 12px;
        background: linear-gradient(90deg, #e2e8f0 25%, #f1f5f9 50%, #e2e8f0 75%);
        background-size: 200% 100%;
        animation: verifyShimmer 1.6s infinite linear;
      }

      /* Tablet */
      @media (max-width: 992px) {
        .vlc-header { padding: 24px 24px 18px; }
        .vlc-body { padding: 20px 24px 28px; }
        .vlc-row-3,
        .vlc-row-1-2 {
          grid-template-columns: 1fr 1fr;
        }
      }

      /* Mobile */
      @media (max-width: 600px) {
        .vlc-header { padding: 20px 16px 16px; }
        .vlc-body { padding: 16px 16px 24px; }
        .vlc-row-3,
        .vlc-row-1-2 {
          grid-template-columns: 1fr;
        }
      }
    `}</style>
  </div>
);

export default VerificationLoadingCard;
